// Per-browser device secret for trusted-device verification. Generated once and kept in
// localStorage; sent as `deviceToken` on login/admin-login/register-complete/admin-reset.
// The server only ever stores sha256(deviceToken) — the raw value never leaves this browser
// except in those auth calls.

const STORAGE_KEY = "oblinor_device_id";

/** Read the device token, creating (and persisting) one on first use. */
export function getOrCreateDeviceToken(): string {
  try {
    const existing = localStorage.getItem(STORAGE_KEY);
    if (existing) return existing;
    const token = crypto.randomUUID();
    localStorage.setItem(STORAGE_KEY, token);
    return token;
  } catch {
    // Storage unavailable (private mode / disabled) — fall back to a throwaway token so
    // auth calls still carry a value; the device just won't be remembered across sessions.
    return crypto.randomUUID();
  }
}
